export default {"src":"/_next/static/media/action.2fed2eb9.svg","height":72,"width":72};